export const apiUrl = process.env.API_URL
export const version = process.env.VERSION
export const redirectUrlIDP = process.env.REDIRECT_URL_IDP
export const sgnUrl = process.env.SGN_URL
export const authorizeUrlIDP = process.env.AUTHORIZE_URL_IDP
export const clientHashIDP = process.env.CLIENT_HASH_IDP
export const appEnv = process.env.NODE_ENV
export const googleGA = process.env.GOOGLE_GA
export const userIdStorageKey = '_user_id';



// WEBPACK FOOTER //
// ./src/config.js